import { Component, Input, Output, EventEmitter } from '@angular/core';
// import { MatTableDataSource } from '@angular/material';
@Component({
  selector: 'vernost-table-row',
  template:`
  <ng-container matColumnDef="{{name}}">
    <th mat-header-cell *matHeaderCellDef> {{title}} </th>
    <td mat-cell *matCellDef="let element"> {{element[value]}} </td>
  </ng-container>
  `
})

export class VernostTableRowComponent {

  // @Input('title') title: string;
  @Input('name') name: string;
  @Input('value') value: string;

//   displayedColumns = ['position', 'name', 'weight', 'symbol'];
//   dataSource = new MatTableDataSource(ELEMENT_DATA);
//   searcheddata: any;

//   applyFilter(filterValue: string) {
//     filterValue = filterValue.trim(); // Remove whitespace
//     filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
//     this.dataSource.filter = filterValue;
//   }

  constructor() {

  }

  ngOnInit() {

  }

}
